import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts";

// Icons from react-icons (optional), or you can use any icon set you like
import { FaEdit, FaTrashAlt } from "react-icons/fa";

const getImageUrl = (path) =>
  `https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/${path}`;

export default function BestSelledProducts() {
  const [products, setProducts] = useState([]);
   const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    subcategory: "",
    price_range: "",
    image_path: "",
    is_promo: false,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProducts();
    fetchCategories();
    fetchSubcategories();
  }, []);

  const fetchProducts = async () => {
    setLoading(true);
    const { data, error } = await supabase.from("best_sellers_products").select("*");
    if (error) setError(error.message);
    else setProducts(data);
    setLoading(false);
  };
 // Fetch categories
  const fetchCategories = async () => {
    const { data, error } = await supabase
      .from("categories")
      .select("id, name")
      .order("name", { ascending: true });
    if (error) setError("Failed to fetch categories: " + error.message);
    else setCategories(data);
  };

  // Fetch subcategories
  const fetchSubcategories = async () => {
    const { data, error } = await supabase
      .from("subcategories")
      .select("id, name, category_id")
      .order("name", { ascending: true });
    if (error) setError("Failed to fetch subcategories: " + error.message);
    else setSubcategories(data);
  };
 
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
      // If category changed, reset subcategory
      ...(name === "category" ? { subcategory: "" } : {}),
    }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split(".").pop();
    const fileName = `${Date.now()}.${ext}`;
    const filePath = `${fileName}`;

    const { error: uploadError } = await supabase.storage
      .from("animalia")
      .upload(filePath, file);

    if (uploadError) {
      alert("Upload failed: " + uploadError.message);
      return;
    }

    setFormData((prev) => ({
      ...prev,
      image_path: filePath,
    }));
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      name: item.name || "",
      category: item.category || "",
      subcategory: item.subcategory || "",
      price_range: item.price_range || "",
      image_path: item.image_path || "",
      is_promo: item.is_promo || false,
    });
  };

  const handleCancel = () => {
    setEditingItem(null);
    setFormData({
      name: "",
      category: "",
      subcategory: "",
      price_range: "",
      image_path: "",
      is_promo: false,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.image_path) {
      alert("Please upload an image before submitting.");
      return;
    }

    const table = supabase.from("best_sellers_products");

    const payload = {
      name: formData.name,
      category: formData.category,
      subcategory: formData.subcategory,
      price_range: formData.price_range,
      image_path: formData.image_path,
      is_promo: formData.is_promo,
    };

    let error;

    if (editingItem) {
      ({ error } = await table.update(payload).eq("id", editingItem.id));
    } else {
      ({ error } = await table.insert([payload]));
    }

    if (error) alert((editingItem ? "Update" : "Insert") + " failed: " + error.message);
    else {
      alert(editingItem ? "Updated successfully" : "Added successfully");
      handleCancel();
      fetchProducts();
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this product?")) return;
    const { error } = await supabase.from("best_sellers_products").delete().eq("id", id);
    if (error) alert("Delete failed: " + error.message);
    else fetchProducts();
  };
  // Filter subcategories based on selected category
  const filteredSubcategories = subcategories.filter((sub) => {
    if (!formData.category) return true; // show all if no category selected
    const selectedCat = categories.find((cat) => cat.name === formData.category);
    return selectedCat ? sub.category_id === selectedCat.id : true;
  });
  return (
    <div style={containerStyle}>
      {/* <h2 style={headerStyle}>Product Manager</h2> */}

      {/* Form */}
      <form onSubmit={handleSubmit} style={formStyle}>
     <h3 style={{ width: "100%", color: "#495057" }}>
  {editingItem ? "Modifier Produit" : "Ajouter Produit"}
</h3>
<input
  type="text"
  name="name"
  placeholder="Nom"
  value={formData.name}
  onChange={handleChange}
  required
  style={inputStyle}
/>
    <select
          name="category"
          value={formData.category}
          onChange={handleChange}
          required
          style={inputStyle}
        >
          <option value="">-- Choisir Catégorie --</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.name}>
              {cat.name}
            </option>
          ))}
        </select>

        <select
          name="subcategory"
          value={formData.subcategory}
          onChange={handleChange}
          required
          style={inputStyle}
          disabled={!formData.category}
        >
          <option value="">-- Choisir Sous-catégorie --</option>
          {filteredSubcategories.map((sub) => (
            <option key={sub.id} value={sub.name}>
              {sub.name}
            </option>
          ))}
        </select>
<input
  type="text"
  name="price_range"
  placeholder="Gamme de prix"
  value={formData.price_range}
  onChange={handleChange}
  required
  style={inputStyle}
/>

<label style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 8 }}>
  <input type="checkbox" name="is_promo" checked={formData.is_promo} onChange={handleChange} />
  En promotion ?
</label>
  <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={{ marginTop: 10 }}
        />
        {formData.image_path && (
          <img
            src={getImageUrl(formData.image_path)}
            alt="Preview"
            style={{ marginTop: 10, maxWidth: 200, borderRadius: 8 }}
          />
        )}

<div style={{ display: "flex", gap: 10, marginTop: 15, width: "100%" }}>
  <button type="submit" style={buttonStyle}>
    {editingItem ? "Mettre à jour" : "Ajouter"}
  </button>
  {editingItem && (
    <button type="button" onClick={handleCancel} style={{ ...buttonStyle, backgroundColor: "#6c757d" }}>
      Annuler
    </button>
  )}
</div>
      </form>

      {/* Cards */}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading && <p>Loading...</p>}

      <div style={cardContainer}>
        {products.map((item) => (
          <div key={item.id} style={cardStyle}>
            <img src={getImageUrl(item.image_path)} alt={item.name} style={smallImageStyle} />
          <h4>{item.name}</h4>
<p>
  <strong>Catégorie :</strong> {item.category}
</p>
<p>
  <strong>Sous-catégorie :</strong> {item.subcategory}
</p>
<p>
  <strong>Prix :</strong> {item.price_range}
</p>
{item.is_promo && <span style={promoTag}>Promotion</span>}
            <div style={{ display: "flex", gap: 10, marginTop: 10, justifyContent: "center" }}>
              <button
                onClick={() => handleEdit(item)}
                style={{ ...iconButtonStyle, backgroundColor: "rgba(255, 65, 180, 0.85)" }}
                aria-label="Edit Product"
                title="Edit Product"
              >
                <FaEdit size={16} />
              </button>
              <button
                onClick={() => handleDelete(item.id)}
                style={{ ...iconButtonStyle, backgroundColor: "rgba(220, 53, 69, 0.85)" }}
                aria-label="Delete Product"
                title="Delete Product"
              >
                <FaTrashAlt size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// Styles

const containerStyle = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: 20,
  backgroundColor: "#f8f9fa",
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  marginTop: 50,
};

const headerStyle = {
  marginBottom: 30,
  color: "#343a40",
};

const formStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: 15,
  maxWidth: 700,
  backgroundColor: "#fff",
  padding: 20,
  borderRadius: 8,
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  marginBottom: 40,
};

const inputStyle = {
  flex: "1 1 200px",
  padding: "10px 12px",
  borderRadius: 6,
  border: "1.5px solid #ced4da",
  fontSize: 16,
  outline: "none",
  transition: "border-color 0.3s",
};

const buttonStyle = {
  padding: "10px 18px",
  border: "none",
  borderRadius: 6,
  color: "#fff",
  fontWeight: "600",
  cursor: "pointer",
  flex: 1,
  backgroundColor: "gray",
  transition: "background-color 0.3s",
};

const cardContainer = {
  display: "flex",
  flexWrap: "wrap",
  gap: 24,
  justifyContent: "center",
};

const cardStyle = {
  width: 260,
  backgroundColor: "#fff",
  borderRadius: 10,
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  padding: 15,
  textAlign: "center",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const smallImageStyle = {
  width: "50%",
  height: 120,
  objectFit: "cover",
  borderRadius: 8,
  marginBottom: 15,
  marginLeft: "70px",
};

const promoTag = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "4px 8px",
  fontSize: "0.8rem",
  borderRadius: 6,
  display: "inline-block",
  marginTop: 4,
};

// New style for icon buttons
const iconButtonStyle = {
  border: "none",
  borderRadius: 6,
  padding: "8px 12px",
  color: "#fff",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "background-color 0.3s",
};
